<template>
  <div class="col-12 heatTreatmentWorkData mb-2">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
        text-align: left;
      "
    >
      熱處理運行數值
    </li>
    <b-row
      class="mx-0 text-center"
      style="margin-top: 1rem; margin-bottom: 0.7rem"
    >
      <div
        v-for="(item, index) in work_value"
        :key="index"
        style="
          width: 160px;
          margin-right: 0.2rem;
          border-bottom: 0.6rem #65646a solid;
          padding: 0.5rem 1rem 0 1rem;
          background-color: transparent;
          color: #65646a;
          font-size: 1rem;
          font-family: dfyuanstd-w5, dfyuanstd-w3;
          cursor: pointer;
        "
        @click="work_value_select = index"
        :class="{
          'ht-work-value-active': work_value_select == index,
        }"
      >
        {{ item.work_date }}
        <span v-if="index > 0 && item.ht_in_process != '-'">{{
          "(" + item.ht_in_process + "重工)"
        }}</span>
      </div>
    </b-row>
    <div
      style="
        width: 100%;
        min-width: 1003px;
        background-color: #ffffff;
        padding: 0px;
      "
    >
      <table
        style="
          color: #ffffff;
          width: 100%;
          min-width: 1003px;
          border: 1px solid #646569;
        "
        class="heatTreatmentArea"
      >
        <tr style="height: 3rem; background-color: #646569">
          <td
            style="
              min-width: 58px;
              width: 58px;
              text-align: right;
              padding-right: 10px;
            "
          >
            入料區
          </td>
          <td style="min-width: 65px; width: 65px">前清洗區</td>
          <td style="min-width: 270px; width: 270px">淬火區</td>
          <td style="min-width: 65px; width: 65px">後清洗區</td>
          <td style="min-width: 230px; width: 230px">回火區</td>
          <td style="min-width: 40px; width: 40px">收料區</td>
        </tr>
        <tr>
          <td colspan="8" style="background-color: #ffffff">
            <div style="position: relative; width: 100%; min-width: 1003px">
              <img
                :src="work_value[work_value_select].heatTreatmentImage"
                alt=""
                style="width: 100%; min-width: 1002px"
              />
              <div
                style="
                  width: 4rem;
                  height: auto;
                  background-color: #646569;
                  color: #ffffff;
                  position: absolute;
                  font-size: 1.5rem;
                  text-align: center;
                  left: 20px;
                  top: 60%;
                  border-radius: 5px;
                "
              >
                {{ work_value[work_value_select].device_name }}
              </div>
            </div>
            <div>
              <table class="sensorTable">
                <tr>
                  <td style="min-width: 4rem">感測點</td>
                  <td
                    v-for="(sensor, index) in work_value[work_value_select]
                      .work_data"
                    :key="index"
                  >
                    {{ sensor.name }}
                  </td>
                </tr>
                <tr>
                  <td style="min-width: 4rem">設定值</td>
                  <td
                    v-for="(sensor, index) in work_value[work_value_select][
                      'work_data'
                    ]"
                    :key="index"
                  >
                    {{ sensor.set_value == "" ? "-" : sensor.set_value }}
                  </td>
                </tr>
                <tr>
                  <td rowspan="2" style="min-width: 4rem">首件時間</td>
                  <td
                    v-for="(date_item, index) in work_value[work_value_select][
                      'first_date_table'
                    ]"
                    :key="index"
                    :colspan="date_item.first_date_colspan"
                  >
                    {{ date_item.first_date }}
                  </td>
                </tr>
                <tr>
                  <td
                    v-for="(sensor, index) in work_value[work_value_select][
                      'work_data'
                    ]"
                    :key="index"
                  >
                    {{ sensor.first.time }}
                  </td>
                </tr>
                <tr>
                  <td style="min-width: 4rem">首件實際值</td>
                  <td
                    v-for="(sensor, index) in work_value[work_value_select][
                      'work_data'
                    ]"
                    :key="index"
                    :style="{
                      'background-color':
                        index == 2 ||
                        index == 3 ||
                        index == 12 ||
                        index == 13 ||
                        index == 17
                          ? '#f2f2f2'
                          : sensor.set_value > 100
                          ? sensor.set_value + 30 < sensor.first.act_val ||
                            sensor.set_value - 30 > sensor.first.act_val
                            ? '#c10000'
                            : sensor.set_value + 15 < sensor.first.act_val ||
                              sensor.set_value - 15 > sensor.first.act_val
                            ? '#ffc100'
                            : '#f2f2f2'
                          : sensor.set_value < 1
                          ? sensor.set_value + 0.1 < sensor.first.act_val ||
                            sensor.set_value - 0.1 > sensor.first.act_val
                            ? '#c10000' 
                            : sensor.set_value + 0.05 < sensor.first.act_val ||
                              sensor.set_value - 0.05 > sensor.first.act_val
                            ? '#ffc100'
                            : '#f2f2f2'
                          : sensor.set_value + 20 < sensor.first.act_val ||
                            sensor.set_value - 20 > sensor.first.act_val
                          ? '#c10000' 
                          : sensor.set_value + 10 < sensor.first.act_val ||
                            sensor.set_value - 10 > sensor.first.act_val
                          ? '#ffc100' 
                          : '#f2f2f2',
                      color:
                        index == 2 ||
                        index == 3 ||
                        index == 12 ||
                        index == 13 ||
                        index == 17
                          ? '#000000'
                          : sensor.set_value > 100
                          ? sensor.set_value + 30 < sensor.first.act_val ||
                            sensor.set_value - 30 > sensor.first.act_val
                            ? '#fff' 
                            : sensor.set_value + 15 < sensor.first.act_val ||
                              sensor.set_value - 15 > sensor.first.act_val
                            ? '#000000'
                            : '#000000'
                          : sensor.set_value < 1
                          ? sensor.set_value + 0.1 < sensor.first.act_val ||
                            sensor.set_value - 0.1 > sensor.first.act_val
                            ? '#fff' 
                            : sensor.set_value + 0.05 < sensor.first.act_val ||
                              sensor.set_value - 0.05 > sensor.first.act_val
                            ? '#000000'
                            : '#000000'
                          : sensor.set_value + 20 < sensor.first.act_val ||
                            sensor.set_value - 20 > sensor.first.act_val
                          ? '#fff' 
                          : sensor.set_value + 10 < sensor.first.act_val ||
                            sensor.set_value - 10 > sensor.first.act_val
                          ? '#000000'
                          : '#000000',
                    }"
                  >
                    {{ sensor.first.act_val }}
                  </td>
                </tr>
                <tr>
                  <td rowspan="2" style="min-width: 4rem">末件時間</td>
                  <td
                    v-for="(date_item, index) in work_value[work_value_select][
                      'last_date_table'
                    ]"
                    :key="index"
                    :colspan="date_item.last_date_colspan"
                  >
                    {{ date_item.last_date }}
                  </td>
                </tr>
                <tr>
                  <td
                    v-for="(sensor, index) in work_value[work_value_select][
                      'work_data'
                    ]"
                    :key="index"
                  >
                    {{ sensor.last.time }}
                  </td>
                </tr>
                <tr>
                  <td style="min-width: 4rem">末件實際值</td>
                  <td
                    v-for="(sensor, index) in work_value[work_value_select][
                      'work_data'
                    ]"
                    :key="index"
                    :style="{
                      'background-color':
                        index == 2 ||
                        index == 3 ||
                        index == 12 ||
                        index == 13 ||
                        index == 17
                          ? '#f2f2f2'
                          : sensor.set_value > 100
                          ? sensor.set_value + 30 < sensor.last.act_val ||
                            sensor.set_value - 30 > sensor.last.act_val
                            ? '#c10000' 
                            : sensor.set_value + 15 < sensor.last.act_val ||
                              sensor.set_value - 15 > sensor.last.act_val
                            ? '#ffc100' 
                            : '#f2f2f2'
                          : sensor.set_value < 1
                          ? sensor.set_value + 0.1 < sensor.last.act_val ||
                            sensor.set_value - 0.1 > sensor.last.act_val
                            ? '#c10000' 
                            : sensor.set_value + 0.05 < sensor.last.act_val ||
                              sensor.set_value - 0.05 > sensor.last.act_val
                            ? '#ffc100' 
                            : '#f2f2f2'
                          : sensor.set_value + 20 < sensor.last.act_val ||
                            sensor.set_value - 20 > sensor.last.act_val
                          ? '#c10000'
                          : sensor.set_value + 10 < sensor.last.act_val ||
                            sensor.set_value - 10 > sensor.last.act_val
                          ? '#ffc100' 
                          : '#f2f2f2',
                      color:
                        index == 2 ||
                        index == 3 ||
                        index == 12 ||
                        index == 13 ||
                        index == 17
                          ? '#000000'
                          : sensor.set_value > 100
                          ? sensor.set_value + 30 < sensor.last.act_val ||
                            sensor.set_value - 30 > sensor.last.act_val
                            ? '#fff'
                            : sensor.set_value + 15 < sensor.last.act_val ||
                              sensor.set_value - 15 > sensor.last.act_val
                            ? '#000000'
                            : '#000000'
                          : sensor.set_value < 1
                          ? sensor.set_value + 0.1 < sensor.last.act_val ||
                            sensor.set_value - 0.1 > sensor.last.act_val
                            ? '#fff'
                            : sensor.set_value + 0.05 < sensor.last.act_val ||
                              sensor.set_value - 0.05 > sensor.last.act_val
                            ? '#000000'
                            : '#000000'
                          : sensor.set_value + 20 < sensor.last.act_val ||
                            sensor.set_value - 20 > sensor.last.act_val
                          ? '#fff' 
                          : sensor.set_value + 10 < sensor.last.act_val ||
                            sensor.set_value - 10 > sensor.last.act_val
                          ? '#000000'
                          : '#000000',
                    }"
                  >
                    {{ sensor.last.act_val }}
                  </td>
                </tr>
              </table>
            </div>

            <div class="htInTable">
              <b-table
                :fields="htInFields"
                :items="work_value[work_value_select].ht_in_data"
                class="text-center ht-in-table-detail"
                fixed
              >
                <template #cell(quench_furn_in_time)="data">
                  <div
                    style="width: 90%; position: relative"
                    class="mt-5 mb-3 mx-auto"
                  >
                    <div>
                      <b-progress max="100" height="3rem">
                        <b-progress-bar
                          value="16.8"
                          style="
                            background-color: #407a6f;
                            text-shadow: 1px 1px 2px #212529;
                          "
                          ><div>
                            {{
                              data.value.start == "-"
                                ? "-"
                                : data.value.start.split(" ")[0]
                            }}
                          </div>
                          <div>
                            {{
                              data.value.start == "-"
                                ? ""
                                : data.value.start.split(" ")[1]
                            }}
                          </div></b-progress-bar
                        >
                        <b-progress-bar
                          value="16.6"
                          style="background-color: #4b8c80"
                        ></b-progress-bar>
                        <b-progress-bar
                          value="16.6"
                          style="background-color: #6fa399"
                        ></b-progress-bar>
                        <b-progress-bar
                          value="16.6"
                          style="background-color: #93bab3"
                        ></b-progress-bar>
                        <b-progress-bar
                          value="16.6"
                          style="background-color: #b7d1cc"
                        ></b-progress-bar>
                        <b-progress-bar
                          value="16.8"
                          style="
                            background-color: #dbe8e6;
                            color: #212529;
                            text-shadow: 1px 1px 2px #cccccc;
                          "
                          ><div>
                            {{
                              data.value.end == "-"
                                ? "-"
                                : data.value.end.split(" ")[0]
                            }}
                          </div>
                          <div>
                            {{
                              data.value.end == "-"
                                ? ""
                                : data.value.end.split(" ")[1]
                            }}
                          </div></b-progress-bar
                        >
                      </b-progress>
                    </div>
                    <div
                      style="
                        width: 108%;
                        height: 2rem;
                        position: absolute;
                        top: -2rem;
                        left: -4%;
                        color: #212529;
                      "
                    >
                      <div
                        style="width: 100%"
                        class="d-flex justify-content-between"
                      >
                        <span> 開始時間 </span>
                        <span> 生產時間 </span>
                        <span> 結束時間 </span>
                      </div>
                    </div>
                    <div
                      style="
                        width: 100%;
                        height: 3rem;
                        position: absolute;
                        top: 0;
                        left: 0;
                      "
                    >
                      <div
                        style="
                          height: 3rem;
                          color: #ffffff;
                          font-size: 1.5rem;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          text-shadow: 1px 1px 2px #212529;
                        "
                      >
                        {{ data.value.run_time }}
                      </div>
                    </div>
                    <div
                      style="
                        width: 98%;
                        height: 3.5rem;
                        border-left: 2px dashed #a4a4a4;
                        border-right: 2px dashed #a4a4a4;
                        position: absolute;
                        top: -0.25rem;
                        left: 1%;
                      "
                    ></div>
                  </div>
                </template>

                <template #cell(tempering_furn_in_time)="data">
                  <div
                    style="width: 90%; position: relative"
                    class="mt-5 mb-3 mx-auto"
                  >
                    <div>
                      <b-progress max="100" height="3rem">
                        <b-progress-bar
                          value="16.8"
                          style="
                            background-color: #407a6f;
                            text-shadow: 1px 1px 2px #212529;
                          "
                          ><div>
                            {{
                              data.value.start == "-"
                                ? "-"
                                : data.value.start.split(" ")[0]
                            }}
                          </div>
                          <div>
                            {{
                              data.value.start == "-"
                                ? ""
                                : data.value.start.split(" ")[1]
                            }}
                          </div></b-progress-bar
                        >
                        <b-progress-bar
                          value="16.6"
                          style="background-color: #4b8c80"
                        ></b-progress-bar>
                        <b-progress-bar
                          value="16.6"
                          style="background-color: #6fa399"
                        ></b-progress-bar>
                        <b-progress-bar
                          value="16.6"
                          style="background-color: #93bab3"
                        ></b-progress-bar>
                        <b-progress-bar
                          value="16.6"
                          style="background-color: #b7d1cc"
                        ></b-progress-bar>
                        <b-progress-bar
                          value="16.8"
                          style="
                            background-color: #dbe8e6;
                            color: #212529;
                            text-shadow: 1px 1px 2px #cccccc;
                          "
                          ><div>
                            {{
                              data.value.end == "-"
                                ? "-"
                                : data.value.end.split(" ")[0]
                            }}
                          </div>
                          <div>
                            {{
                              data.value.end == "-"
                                ? ""
                                : data.value.end.split(" ")[1]
                            }}
                          </div></b-progress-bar
                        >
                      </b-progress>
                    </div>
                    <div
                      style="
                        width: 108%;
                        height: 2rem;
                        position: absolute;
                        top: -2rem;
                        left: -4%;
                        color: #212529;
                      "
                    >
                      <div
                        style="width: 100%"
                        class="d-flex justify-content-between"
                      >
                        <span> 開始時間 </span>
                        <span> 生產時間 </span>
                        <span> 結束時間 </span>
                      </div>
                    </div>
                    <div
                      style="
                        width: 100%;
                        height: 3rem;
                        position: absolute;
                        top: 0;
                        left: 0;
                      "
                    >
                      <div
                        style="
                          height: 3rem;
                          color: #ffffff;
                          font-size: 1.5rem;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          text-shadow: 1px 1px 2px #212529;
                        "
                      >
                        {{ data.value.run_time }}
                      </div>
                    </div>
                    <div
                      style="
                        width: 98%;
                        height: 3.5rem;
                        border-left: 2px dashed #a4a4a4;
                        border-right: 2px dashed #a4a4a4;
                        position: absolute;
                        top: -0.25rem;
                        left: 1%;
                      "
                    ></div>
                  </div>
                </template>
              </b-table>
            </div>

            <div class="htInquire text-left">
              <div
                class="go-ht-inquire-button"
                @click="
                  goHtInquire(
                    work_value[work_value_select].device_name,
                    work_value[work_value_select].start_time,
                    work_value[work_value_select].end_time
                  )
                "
              >
                熱處理參數明細
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "heatTreatmentWorkData",
  data() {
    return {
      emptyValue: [
        {
          device_name: "-",
          work_date: "-/-",
          first_date_table: [
            {
              first_date: "-",
              first_date_colspan: 19,
            },
          ],
          last_date_table: [
            {
              last_date: "-",
              last_date_colspan: 19,
            },
          ],
          ht_in_data: [
            {
              quench_furn_in_time: {
                start: "-",
                end: "-",
                run_time: "-",
              },
              tempering_furn_in_time: {
                start: "-",
                end: "-",
                run_time: "-",
              },
            },
          ],
          work_data: [
            {
              name: "前清洗",
              sensor_name: "cln_bf_temp",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "烘乾機",
              sensor_name: "dryer_cln_bf_temp",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "淬火1區",
              sensor_name: "quench_furn_temp1",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "淬火2區",
              sensor_name: "quench_furn_temp2",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "碳勢1",
              sensor_name: "cp1",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "淬火3區",
              sensor_name: "quench_furn_temp3",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "淬火4區",
              sensor_name: "quench_furn_temp4",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "淬火5區",
              sensor_name: "quench_furn_temp5",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "碳勢2",
              sensor_name: "cp2",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "淬火6區",
              sensor_name: "quench_furn_temp6",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "淬火槽",
              sensor_name: "quench_tank_temp",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "後清洗",
              sensor_name: "cln_af_temp",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "回火1區",
              sensor_name: "tempering_furn_temp1",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "回火2區",
              sensor_name: "tempering_furn_temp2",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "回火3區",
              sensor_name: "tempering_furn_temp3",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "回火4區",
              sensor_name: "tempering_furn_temp4",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "回火5區",
              sensor_name: "tempering_furn_temp5",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "發黑槽",
              sensor_name: "carb_tank_temp",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
            {
              name: "烘乾機",
              sensor_name: "dryer_temp",
              set_value: "-",
              first: { act_val: "-", date: "-", time: "-" },
              last: { act_val: "-", date: "-", time: "-" },
            },
          ],
        },
      ],
      work_value: [],
      work_value_select: 0,
    };
  },
  created() {
    let vm = this;
    vm.work_value = vm.emptyValue;
  },
  computed: {
    ...mapGetters({
      htWorkData: "htWorkData/get_htWorkDataItem",
      htInFields: "htWorkData/get_htInFields",
      sideBar: "sideBarTree/get_sideBar",
    }),
  },
  watch: {
    htWorkData: {
      handler() {
        let vm = this;
        vm.setHtWorkData();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      set_fromWorkOrderHistoryParams:
        "heatTreatmentInquireResult/set_fromWorkOrderHistoryParams",
      set_sideBarSelect: "sideBarTree/set_sideBarSelect"
    }),
    setHtWorkData() {
      let vm = this;
      if (vm.htWorkData.length == 0) {
        vm.work_value = vm.emptyValue;
      } else {
        vm.work_value = vm.htWorkData;
      }
      vm.work_value.forEach((data, index) => {
        let device_name = data.device_name;
        if (device_name == 'A2' || device_name == 'B2' || device_name == 'C2') {
          vm.work_value[index].heatTreatmentImage = require("../assets/heat-treatment2.png");
        } else if (device_name == 'D2') {
          vm.work_value[index].heatTreatmentImage = require("../assets/heat-treatmentD2.png");
        } else if (device_name == 'A') {
          vm.work_value[index].heatTreatmentImage = require("../assets/heat-treatmentA.png");
        } else if (device_name == 'B') {
          vm.work_value[index].heatTreatmentImage = require("../assets/heat-treatmentB.png");
        } else if (device_name == 'C') {
          vm.work_value[index].heatTreatmentImage = require("../assets/heat-treatmentC.png");
        } else if (device_name == 'D') {
          vm.work_value[index].heatTreatmentImage = require("../assets/heat-treatmentD.png");
        } else if (device_name == 'E') {
          vm.work_value[index].heatTreatmentImage = require("../assets/heat-treatmentE.png");
        } else {
          vm.work_value[index].heatTreatmentImage = require("../assets/heat-treatmentA.png");
        }
      });
    },
    goHtInquire(device, start, end) {
      let vm = this;
      if (!device) {
        device = "";
      }
      if (!start) {
        start = "";
      }
      if (!end) {
        end = "";
      }
      let htProcess = "";
      if (vm.sideBar.elecboard.other.process['heat-treatment'].group['heat-treatment1'].device.indexOf(device) != -1) {
        htProcess = "factory_one-7";
      } else if (vm.sideBar.elecboard.other.process['heat-treatment'].group['heat-treatment2'].device.indexOf(device) != -1) {
        htProcess = "factory_two-7";
      }
      vm.set_fromWorkOrderHistoryParams({
        from: true,
        start: start,
        end: end,
        device: device,
        htProcess: htProcess,
      });
      vm.set_sideBarSelect(["statisticstable", "heattreatmentinquire"]);
      vm.$router.push({ path: "/index/statisticstable" });
    },
  },
};
</script>

<style lang="scss">
.heatTreatmentWorkData {
  overflow: auto;
  text-align: center;
  font-size: 12px;
}
.sensorTable {
  border-collapse: collapse;
  width: 97%;
  margin-right: auto;
  margin-left: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.sensorTable tr {
  border: 1px solid #999999;
}
.sensorTable td {
  width: 5rem;
  height: 3rem;
  border: 0.5px solid #999999;
}

.sensorTable tr:nth-child(1) {
  color: #4b8c80;
  white-space: nowrap;
}
.sensorTable tr:nth-child(2) {
  color: #212529;
}
.sensorTable tr:nth-child(3) {
  color: #4b8c80;
}
.sensorTable tr:nth-child(4) {
  color: #4b8c80;
}
.sensorTable tr:nth-child(5) {
  color: #212529;
}
.sensorTable tr:nth-child(6) {
  color: #4b8c80;
}
.sensorTable tr:nth-child(7) {
  color: #4b8c80;
}
.sensorTable tr:nth-child(8) {
  color: #212529;
}
.sensorTable tr:nth-child(2) {
  background-color: #f2f2f2;
}
.sensorTable tr:nth-child(5) {
  background-color: #f2f2f2;
}
.sensorTable tr:nth-child(8) {
  background-color: #f2f2f2;
}

.htInTable {
  width: 97%;
  margin-right: auto;
  margin-left: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}

.ht-in-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.ht-in-table-detail thead th {
  border-top: 1px solid;
}
.ht-in-table-detail th,
.ht-in-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  vertical-align: middle !important;
}
.ht-in-table-detail td {
  font-size: 1rem;
}
.ht-in-table-detail th:first-child,
.ht-in-table-detail td:first-child {
  border-left: 1px solid;
}
.ht-in-table-detail {
  margin-bottom: 0px;
}
.ht-in-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.ht-in-table-detail tr td {
  background-color: #ffffff;
}

.ht-work-value-active {
  border-bottom: 0.6rem #ff6b00 solid !important;
  background-color: #ff6b00 !important;
  color: #ffffff !important;
  border-top-left-radius: 0.63rem;
  border-top-right-radius: 0.63rem;
}

.go-ht-inquire-button {
  border-radius: 5px;
  background-color: #4b8c80;
  color: #ffffff;
  padding: 0px 13px;
  width: 10rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.125rem;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
  text-align: center;
  margin: 0px 0px 1rem 1rem;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/heatTreatmentWorkData.vue